module.exports = __webpack_public_path__ + "static/media/event.a0d423b9.png";